import "@ds/components/Tag";
const o = "primary";
var e = /* @__PURE__ */ ((r) => (r.Center = "center", r.Left = "left", r))(e || {});
export {
  e as AlignmentEnum,
  o as DEFAULT_TAG_VARIANT
};
